// extracted by mini-css-extract-plugin
export default {"grid":"PyLkIma0ROJY7EObAKEL","dragOverlay":"bYhRK_iOch1I1Yb998am","dragOverlayImage":"XnZncTgkJiMmTFklEnR8"};